import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { beaumontConfig } from "./data";

export default function BeaumontPage() {
  return <CityPageTemplate config={beaumontConfig} />;
}